// Libs
import { useState } from 'react';
import { NavContentVisibility } from './nav-content-visibility.interfaces';

const useNavContentVisibility = (): NavContentVisibility => {
  const [navContentVisible, setNavContentVisible] = useState(false);

  /**
   * Toggle menu in nav content
   */
  const toggleNavContentVisibility = () => {
    setNavContentVisible((previousValue) => !previousValue);
  };

  /**
   * Closes nav content menu on click away
   */
  const handleClickAwayNavContent = () => {
    setNavContentVisible(false);
  };

  return {
    navContentVisible,
    toggleNavContentVisibility,
    handleClickAwayNavContent,
  };
};

export default useNavContentVisibility;
